<template>
  <b-modal
      id="1"
      :title="title"
      v-model="isOpenLocal"
      size="lg"
      scrollable
      :hide-footer="hideFooter"
      :ok-title="capitalize($t('validate'))"
      :cancel-title="capitalize($t('cancel'))"
      @hide="tryCloseVatDeclarationModal"
      @hidden="handleCancel"
      @ok="handleOk"
  >
    <b-card>
      <validation-observer
          ref="observerRef"
          #default="{handleSubmit}">
        <b-form
            @keydown.enter.stop.prevent=""
            @submit.prevent="handleSubmit(submitValidatedVatDeclarationLocal)">
          <form-vatDeclaration :vatDeclaration="vatDeclarationLocal"/>
          <button ref="submitVatDeclarationFormRef"
                  class="d-none"></button>
        </b-form>
      </validation-observer>
    </b-card>

  </b-modal>
</template>

<script>
import { ref, computed, watch } from '@vue/composition-api'
import { ValidationObserver } from 'vee-validate'
import { capitalize } from '../../utils/filter'

import useAPI from '../../utils/useAPI'
import FormVatDeclaration from '../form/VatDeclaration'

export default {
  components: {
    ValidationObserver,
    FormVatDeclaration
  },
  props: {
    vatDeclaration: {
      type: Object,
      default: () => {}
    },
    title: {
      type: String,
      default: ''
    },
    isOpen: {
      type: Boolean,
      default: false
    },
    isView: {
      type: Boolean,
      default: false
    }
  },
  setup (props, { emit }) {
    // ------------------------------------------------
    // Data
    // ------------------------------------------------
    const isOpenLocal = ref(false)
    const vatDeclarationLocal = ref(props.vatDeclaration)
    const submitVatDeclarationFormRef = ref(null)
    const observerRef = ref(null)

    // ------------------------------------------------
    // Computed
    // ------------------------------------------------
    const { currentBreakPoint } = useAPI()

    const hideFooter = computed(() => {
      return !['xs', 'sm'].includes(currentBreakPoint.value)
    })

    // ------------------------------------------------
    // Watch
    // ------------------------------------------------
    watch(isOpenLocal, (val) => {
      emit('update:isOpen', val)
    })
    watch(vatDeclarationLocal, (val) => {
      emit('update:vatDeclaration', val)
    })

    // ------------------------------------------------
    // Methods
    // ------------------------------------------------
    const tryCloseVatDeclarationModal = (modalVatDeclaration) => {
      if (modalVatDeclaration.trigger == 'backdrop') {
        // Click outside
        modalVatDeclaration.preventDefault()
        submitVatDeclarationFormRef.value.click()
      }
    }

    const submitValidatedVatDeclarationLocal = () => {
      emit('submitValidated')
    }

    const handleOk = async (bvModalEvent) => {
      bvModalEvent.preventDefault()

      const isValid = await observerRef.value.validate()
      if (isValid) {
        submitValidatedVatDeclarationLocal()
      }
    }

    const handleCancel = () => {}

    // ------------------------------------------------
    // Mounted
    // ------------------------------------------------

    // ------------------------------------------------
    // Setup
    // ------------------------------------------------
    return {
      // Components
      capitalize,

      // Data
      isOpenLocal,
      vatDeclarationLocal,
      submitVatDeclarationFormRef,
      observerRef,

      // Computed
      hideFooter,

      // Methods
      tryCloseVatDeclarationModal,
      submitValidatedVatDeclarationLocal,
      handleOk,
      handleCancel,
    }
  },
  data () {
    return {}
  },
  computed: {},
  watch: {
    vatDeclaration: function (val) {
      this.vatDeclarationLocal = val
    },
    isOpen: function (val) {
      this.isOpenLocal = val
    }
  },
  methods: {},
  mounted () {
  },
  created () {
  }
}
</script>

<style lang="scss">

</style>